// Typelizer digest 17b3844625f28bbccae522603d4688b0
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /c/:company_id/overview/month_end */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/overview/month_end', {}, options),
    method: 'get',
  }),
}
